import { twMerge } from "tailwind-merge";

export function Label({
  children,
  elementType,
  htmlFor,
  className,
}: {
  children: React.ReactNode;
  elementType: "label" | "legend" | "span";
  htmlFor?: string;
  className?: string;
}) {
  const Element = elementType;

  return (
    <Element
      className={twMerge(
        "block text-sm font-medium leading-6 text-gray-900",
        className
      )}
      htmlFor={htmlFor}
    >
      {children}
    </Element>
  );
}
